import { Collection, WhereField } from '../../shared/constants'
import { deleteDoc, getAllDocsByQueries } from './collectionBaseWorker'
import { where } from "firebase/firestore"

export const getAllContractsByMonthlyId = async ({ id }) => {
    return await getAllDocsByQueries({
        collection: Collection.MONTHLIES_CONTRACTS,
        queries: [
            where(WhereField.MONTHLY_ID, "==", id)
        ]
    })
}

export const deleteContractById = async ({ id }) => {
    await deleteDoc({ collection: Collection.MONTHLIES_CONTRACTS, id: id })
}